"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.property = void 0;

var genericTuple_1 = require("../../arbitrary/genericTuple");

var ConvertersProperty_1 = require("./ConvertersProperty");

var Property_generic_1 = require("./Property.generic");

var AlwaysShrinkableArbitrary_1 = require("../../arbitrary/_internals/AlwaysShrinkableArbitrary");

var Converters_1 = require("../arbitrary/definition/Converters");

function property() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length < 2) throw new Error('property expects at least two parameters');
  var arbs = args.slice(0, args.length - 1);
  var p = args[args.length - 1];
  return (0, ConvertersProperty_1.convertFromNextPropertyWithHooks)(new Property_generic_1.Property((0, genericTuple_1.genericTuple)(arbs.map(function (arb) {
    return (0, Converters_1.convertFromNext)(new AlwaysShrinkableArbitrary_1.AlwaysShrinkableArbitrary((0, Converters_1.convertToNext)(arb)));
  })), function (t) {
    return p.apply(void 0, _toConsumableArray(t));
  }));
}

exports.property = property;